import { render, staticRenderFns } from "./metadata_item.vue?vue&type=template&id=7865f25a&"
import script from "./metadata_item.vue?vue&type=script&lang=js&"
export * from "./metadata_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports